import api from 'Application/api/api';

const deleteTemplateCustomTopic = (templateId, customTopicId, cancelToken = null) =>
    api.delete(`project-manager/templates/${templateId}/custom-topics/${customTopicId}`, {
        cancelToken,
    });

export default deleteTemplateCustomTopic;
